import React from "react";
import Box from "@mui/material/Box";
import VideoOffOutline from "mdi-material-ui/VideoOffOutline";

const NoVideo = ({ isMobile }) => {
  return (
    <Box sx={{ textAlign: "center", m: 2, mt: isMobile ? 4 : 16, mb: isMobile ? 4 : 16 }}>
      <div className="lesson-state__icon lesson-state__icon--muted">
        <VideoOffOutline />
      </div>
      <h3 className="lesson-state__title">O vídeo desta aula ainda não está disponível</h3>
      <p className="lesson-state__text">
        Pode estar em fase de carregamento. Se continuar indisponível, entra em contacto com o produtor do curso para mais informações.
      </p>
    </Box>
  );
};

export default NoVideo;
